import React, { useState, useEffect } from 'react';
import './Login.css';
import RightBanner from './RightBanner';
import { Link } from 'react-router-dom';
import { loginUser } from '../../services/login';
import { Alert } from "react-bootstrap";
import Hide from "../../assets/images/hide.svg";
import Show from "../../assets/images/show.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import loading from "../../assets/images/loader_grey.gif";
import SocialLogin from './SocialLogin';


function Login(props) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [alertMsg, setAlertMsg] = useState(false);
    const [wrongCreds, setWrongCreds] = useState(false);
    const errMsgs = ["Username or password is incorrect!", "Internal Server Error!"]
    const [loginErrMsg, setLoginErrMsg] = useState(errMsgs[0]);
    const [errUsername, setErrUsername] = useState(false);
    const [errPassword, setErrPassword] = useState(false);
    const [showPswd, setShowPswd] = useState(false);
    const [error, setError] = useState('');

    const showPswdHandler = () => {
        setShowPswd(!showPswd);
    }


    var usernameInp, passwordInp;

    useEffect(() => {
        usernameInp = document.getElementById("username-input");
        passwordInp = document.getElementById("password-input");
    });



    const validateFields = () => {
        let pass = true;
        if (username.trim() == "") {
            setErrUsername(true);
            usernameInp.classList.add("error-input-border");
            pass = false;
        }
        if (password == "") {
            setErrPassword(true);
            passwordInp.classList.add("error-input-border");
            pass = false;
        }
        return pass;
    }

    const onChangeUsername = (val) => {
        if (errUsername == true) {
            usernameInp.classList.remove("error-input-border");
            setErrUsername(false);
        }
        setUsername(val);

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!emailRegex.test(val)) {
          setError('Please enter a valid email address');
        } else {
          setError('');
        }
    }
    const onChangePassword = (val) => {
        if (errPassword == true) {
            passwordInp.classList.remove("error-input-border");
            setErrPassword(false);
        }
        setPassword(val);
    }


    const handleSubmit = async e => {
        e.preventDefault();
        if (!validateFields()) {
            return;
        } else {
            setAlertMsg(true);
            try {
                const response = await loginUser({
                    username,
                    password
                });
                if (response.status) {
                    setAlertMsg(false);
                    props.token(response.data);
                    props.status("Y");
                    setLoginErrMsg(null);
                    setWrongCreds(false);
                    setUsername("");
                    setPassword("");
                    sessionStorage.setItem("statusFlag", 1);
                } else {
                    setLoginErrMsg(errMsgs[0]);
                    setWrongCreds(true);
                    setAlertMsg(false);
                }
            } catch (error) {
                setLoginErrMsg(errMsgs[1]);
                setWrongCreds(true);
                setAlertMsg(false);
            }
        }

    }

    return (
        <>
            <div className="d-flex flex-column flex-root login-bg">
                <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                    <div class="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12 order-2 order-lg-1 right-text">
                        <div class="bg-body d-flex flex-column flex-center rounded-4 w-md-600px p-10">
                            <div class="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-400px">
                                <div class="d-flex flex-center flex-column flex-column-fluid pb-15 pb-lg-20">
                                <Alert className="login-alerts" show={wrongCreds} onClose={() => setWrongCreds(false)} variant="danger" dismissible>
                                {loginErrMsg}
                            </Alert>
                            {alertMsg ?
                                <SweetAlert
                                    title=""
                                    timeout={10000}
                                    showConfirm={false}
                                    style={{ width: "200px", height: "100px" }}
                                > <img src={loading} width="50px" height="50px" />
                                </SweetAlert>
                                : <></>}

                                    <form class="form w-100" id="kt_sign_in_form" onSubmit={handleSubmit}>
                                        <div class="text-center mb-11">
                                        <Link to="https://slidesmap.com" >
                                            <h1 class="logo-text">
                                                Slidesmap
                                            </h1>
                                        </Link>
                                        </div>

                                        <SocialLogin />

                                        <div class="separator separator-content my-14">
                                            <span class="w-125px text-gray-500 fw-semibold fs-7">Or with email</span>
                                        </div>

                                        <div class="fv-row mb-8">
                                            <input type="email" value={username} id="username-input"
                                        onChange={(e) => onChangeUsername(e.target.value)}
                                        placeholder="Email" name="email" autocomplete="off" class="form-control bg-transparent" />
                                            <span className="input-pre-text"><small>&ensp;</small></span>
                                            {errUsername == true ? <span className="input-error-text ml-1rem" ><small>Please Enter Username.</small></span> : null}
                                            {error && <span className="input-error-text ml-1rem" ><small>{error}</small></span>} 
                                        </div>

                                        <div class="fv-row mb-3">
                                            <input type={showPswd ? "text" : "password"} value={password} id="password-input"
                                        onChange={(event) => onChangePassword(event.target.value)} placeholder="Password" name="password" autocomplete="off" class="form-control bg-transparent" />
                                        <div className="show-hide-pswd-eye" onClick={() => { showPswdHandler() }}>
                                        {showPswd ? <img src={Hide} /> : <img src={Show} />}
                                    </div>
                                    <span className="input-pre-text"><small>&ensp;</small></span>
                                    {errPassword == true ? <span className="input-error-text ml-1rem" ><small>Please Enter Password.</small></span> : null}
                                        </div>

                                        <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                                            <div></div>
                                            <Link to="/forgot-password" className="link-primary"> Forgot Password ?
                                            </Link>
                                        </div>

                                        <div class="d-grid mb-10">
                                            <button type="submit" id="kt_sign_in_submit" class="btn btn-primary">

                                                <span class="indicator-label">
                                                    Sign In</span>

                                                <span class="indicator-progress">
                                                    Please wait...    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        </div>

                                        <div class="text-gray-500 text-center fw-semibold fs-6">
                                            Not a Member yet?
                                            <Link to="/signup" className="link-primary">Sign up
                                            </Link>
                                           
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <RightBanner />
                </div>
            </div>
        </>
    )
}

export default Login;
